module.exports = __webpack_public_path__ + "assets/img/download_blue.439ab95f.svg";